import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c34a0358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-background-contents shadow" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopMessage = _resolveComponent("TopMessage")!
  const _component_Usage = _resolveComponent("Usage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TopMessage)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Usage)
    ])
  ]))
}